import { render, staticRenderFns } from "./reportTable.vue?vue&type=template&id=af7cca84&scoped=true&"
import script from "./reportTable.vue?vue&type=script&lang=js&"
export * from "./reportTable.vue?vue&type=script&lang=js&"
import style0 from "./reportTable.vue?vue&type=style&index=0&id=af7cca84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af7cca84",
  null
  
)

export default component.exports